module.exports = __webpack_public_path__ + "img/PROCEDIMIENTO_REALIZADO.png";